if (!customElements.get('collapsible-accordion')) {
  customElements.define(
    'collapsible-accordion',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return

        this.details = this.querySelector('details')
        this.summary = this.querySelector('summary')
        this.answer = this.querySelector('.collapsible-content__answer')
        if (!this.details || !this.summary || !this.answer) return

        this.initialized = true
        this.onSummaryClick = this.onSummaryClick.bind(this)
        this.onBlockSelect = this.onBlockSelect.bind(this)
        this.summary.addEventListener('click', this.onSummaryClick)
        document.addEventListener('shopify:block:select', this.onBlockSelect)
      }

      disconnectedCallback() {
        if (!this.initialized) return

        this.summary.removeEventListener('click', this.onSummaryClick)
        document.removeEventListener('shopify:block:select', this.onBlockSelect)
        this.animation?.cancel()
        this.animation = null
        this.answer.style.height = ''
        this.answer.style.opacity = ''
        this.answer.style.overflow = ''
        this.isClosing = false
        this.initialized = false
      }

      onSummaryClick(event) {
        event.preventDefault()
        if (this.details.open && !this.isClosing) {
          this.close()
        } else {
          this.open()
        }
      }

      onBlockSelect(event) {
        if (event.detail.blockId === this.dataset.blockId) this.open()
      }

      open() {
        if (this.details.open && !this.isClosing) return

        const group = this.closest('.collapsible-content__accordion-group')
        group?.querySelectorAll('collapsible-accordion').forEach((accordion) => {
          if (accordion !== this) accordion.close()
        })
        this.animate(true)
      }

      close() {
        if (!this.details.open) return
        this.animate(false)
      }

      animate(open) {
        const startHeight = this.answer.getBoundingClientRect().height
        const startOpacity = this.details.open
          ? Number.parseFloat(window.getComputedStyle(this.answer).opacity) || 0
          : 0
        this.animation?.cancel()

        if (open) {
          this.details.open = true
          this.isClosing = false
        } else {
          this.isClosing = true
        }

        const endHeight = open ? this.answer.scrollHeight : 0
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.finish(open)
          return
        }

        this.answer.style.overflow = 'hidden'
        const animation = this.answer.animate(
          {
            height: [`${startHeight}px`, `${endHeight}px`],
            opacity: [startOpacity, open ? 1 : 0],
          },
          { duration: 250, easing: 'cubic-bezier(0.25, 1, 0.5, 1)' }
        )
        this.animation = animation
        animation.onfinish = () => {
          if (this.animation === animation) this.finish(open)
        }
      }

      finish(open) {
        this.details.open = open
        this.isClosing = false
        this.animation = null
        this.answer.style.height = ''
        this.answer.style.opacity = ''
        this.answer.style.overflow = ''
      }
    }
  )
}
